module.exports = __webpack_public_path__ + "img/insurance.d73d849a.svg";